import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleCreateEvent(
  list: Identifiable<List>,
  data: Boundaries["createEvent"]["success"],
): Identifiable<List> {
  const { event, list: target } = data;
  const isTargetList = target.uuid === list.uuid;

  return isTargetList
    ? { ...list, events: [...list.events, event] }
    : {
        ...list,
        subLists: list.subLists.map((subList) =>
          handleCreateEvent(subList, data),
        ),
      };
}

export { handleCreateEvent };
